/*
 * Copyright (c) 2019 Frontier Developments PLC.
 */

import {Component, Vue} from 'vue-property-decorator';
import Utils from '@/services/utils';

/**
 * Build version component.
 * @author Jonny Cook <jcook@frontier.co.uk>
 */
@Component({
    name: 'c-build-version',
})
export default class BuildVersion extends Vue {
    /**
     * Version getter.
     * @return {string}
     */
    get version(): string {
        return Utils.getVersion();
    }

    /**
     * Enabled getter.
     * @return {boolean}
     */
    get enabled(): boolean {
        return (process.env.VUE_APP_BUILD_VERSION || 'production') === 'develop';
    }
}
